module.exports = "https://static.wanderu.com/ui-react/_next/static/media/ca.dc41a827.svg";